import { render } from "./RoleRotator.vue?vue&type=template&id=520da547&scoped=true"
import script from "./RoleRotator.vue?vue&type=script&lang=js"
export * from "./RoleRotator.vue?vue&type=script&lang=js"

import "./RoleRotator.vue?vue&type=style&index=0&id=520da547&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Gelo\\Desktop\\Firebase Project\\eporrtfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520da547"]])

export default __exports__